import * as React from 'react';
import { ToolbarConfig, MenuConfig } from '@tencent/workbench';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import { TOOLBAR_SHAPE } from '@editor/src/img/pageIndex';
import i18n from '@i18next/i18n';
import { wrapIdForBig } from '@framework/workbench/util/wrap-id-util';

const style: React.CSSProperties = {
    width: '318px',
    overflow: 'hidden',
    zoom: 1,
    padding: 0,
    height: 'auto',
    position: 'relative',
};

const popUpStyle: React.CSSProperties = {
    overflow: 'hidden',
};

export const config = {
    id: ActionType.INSERT_SHAPE,
    tipMsg: i18n.t('插入形状'),
    title: i18n.t('形状'),
    titleCrop: i18n.t('裁剪为形状'),
    icon: TOOLBAR_SHAPE,
};

export const CUSTOM_SHAPE: MenuConfig = {
    name: `${config.id}-parent-custom`,
    style,
};

export const TAILOR_PIC_SHAPE: MenuConfig = {
    name: ActionType.TAILOR_PIC_SHAPE,
    style,
};

export const TOOLBAR_ITEMS: ToolbarConfig[] = [
    {
        name: config.id,
        tooltip: config.tipMsg,
        icon: <img src={config.icon} alt={''}/>,
    },
    {
        name: wrapIdForBig(config.id),
        tooltip: config.tipMsg,
        text: i18n.t('形状'),
        icon: <img src={config.icon} alt={''}/>,
        style: {
            width: 'auto',
        },
    },
];


export const INSERT_SHAPE_MENU_CONFIGS: MenuConfig[] = [
    {
        name: `${config.id}-parent`,
        content: config.title,
        icon: <img src={config.icon} alt={''}/>,
    },
    {
        name: `${config.id}-parent-crop`,
        content: config.titleCrop,
        icon: <img src={config.icon} alt={''}/>,
    },
    CUSTOM_SHAPE,
    TAILOR_PIC_SHAPE,
];
